import { PostAppNotificationTemplate } from 'src/admin/admin-portal/component/account-opening/model/postAppNotificationTemplate.model';
import { AlloySetting } from 'src/admin/admin-portal/component/settings/model/alloy-integration.type';
import { ChatIntegrationProvider } from 'src/admin/admin-portal/component/settings/model/chat-integration.type';
import { PostAppAnimationType } from 'src/admin/admin-portal/component/settings/model/general-settings.type';
import { LoanProduct, OLALoanDetail, ProductDisclosure } from './loans.model';
import { ManagedContentItem } from '@app/common-models/managed-content-item';
export class LenderConfiguration {
  id = '';
  originatingBranchId: '';
  adaLevel = '';
  address1 = '';
  address2 = '';
  adminLenderEmail = '';
  brand: Brand = new Brand();
  businessAssociations: BusinessAssociation[] = [new BusinessAssociation()];
  city = '';
  consumerLoanCode = '';
  consumerTemplateMapping: ConcurrentDictionary<ConsumerType, string> = new ConcurrentDictionary();
  confettiEnabled = true;
  contactPhone = '';
  contactPhoneExtension = '';
  disableGetFundingAccount = false;
  chatIntegration: ChatIntegration = new ChatIntegration();
  contacts: LenderContact[] = [new LenderContact()];
  copyright = '';
  darkMode = false;
  darkModeLogo = '';
  daysOfOperation = '';
  dictionaryOverride = {};
  enableHostPrefill = false;
  enableHomebankingPrefillOLA = false;
  enableHomebankingPrefillOAO = false;
  excludedCards: string[] = [];
  features: Feature[] = [new Feature()];
  hoursOfOperation = '';
  isAddressBlock = false;
  isAllowOnlyOneCheckingAccount = false;
  isAutoAvailable = false;
  isBusinessMembershipNotAllowed = false;
  isChatBlock = false;
  isEmailBlock = false;
  isOAOInstatouchEnabled = false;
  isOAOSsnRequired = false;
  isPaymentAvailable = false;
  isPhoneBlock = false;
  isRequiredEmploymentHistory = false;
  lenderCode = '';
  lenderDomainName = '';
  lenderEmail = '';
  lenderLogoUrl = '';
  lenderName = '';
  lenderWebsiteUrl = '';
  mainColor = '';
  // TODO: this is an enum that should be
  // number array in UI. How to handle?
  oidConfigName: string = null;
  // olaLenderConfiguration: OLALenderConfiguration = new OLALenderConfiguration();
  shouldFetchAdminDisclosures = false;
  state = '';
  supportedPaymentMethod: PaymentMethod = new PaymentMethod();
  membershipConfig: MembershipConfig[] = [new MembershipConfig()];
  swbcPaymentAccountId = '';
  tenantId = '';
  timezone = '';
  widgetConfiguartion: WidgetConfiguration = new WidgetConfiguration();
  zipCode = '';
  isInstaTouchMockupEnabled = false;
  showOaoNewApp = false;
  showOlaNewApp = false;
  showEconsentForCoApp = false;
  isHostPrefillMockDataEnable = false;
  sendRegistrationEmailForOao = false;
  sendRegistrationEmailForOla = false;
  footerLinks: FooterLinks = new FooterLinks();
  enableEnhancedProductSelection = false;
  statusCheckTimeOut: number = null;
  adminStipulations: AdminStipulation[] = [new AdminStipulation()];
  generalSettings: GeneralSettings = new GeneralSettings();
  enableRecaptcha = true;
  enableRegistrationOptionalSSN = false;
  googleAnalytics: GoogleAnalytics = new GoogleAnalytics();
  googleTagManager: GoogleTagManager = new GoogleTagManager();
  alloySettings: AlloySetting = new AlloySetting();
  homebankingAutoLogin = false;
  managedContents: ManagedContentItem[] = [];
}

/** TODO: For the sake of the Lender Config Tool (which is readonly for this property), we need to set a default value here.
 * We should DEPRECATE this when the Lender Config Tool is deprecated, and triple check nulls are fully functional. */
export class ChatIntegration {
  provider: ChatIntegrationProvider = 'none'; // Enum of chat providers (Admin Portal defined)
  providerId = ''; // String id of chat provider
}

export class GeneralSettings {
  postAppAnimation: PostAppAnimationType = 'conservative';
}

export class ConcurrentDictionary<TKey, TValue> {
  isEmpty = false;
  count: number = null;
  keys: TKey[] = null;
  values: TValue[] = null;
}

export class BusinessAssociation {
  name = '';
  imageUrl = '';
  enabled = false;
  businessUrl = '';
  alternativeText = '';
}

export enum ConsumerType {
  PrimaryBorrower = 1,
  JointPrimaryBorrower = 2,
  CoApplicant = 3,
  JointCoApplicant = 4
}

export class LenderContact {
  type = '';
  description = '';
  value = '';
  additionalValue = '';
}

/**
 * This was really only ever used for google analytics/tag mamager
 * Updated the config-sugar to reflect as much. BE 2/23
 * Should re-evalute this
 */
export class Feature {
  label = '';
  isEnabled = false;
  value = '';
}

export class Disclosure {
  disclosureId = '';
  title = '';
  isPDFFile = false;
  pDFFileName = '';
  content = '';
  placeHolderAcceptText = '';
  storageId = '';
  agreedDateStorageId = '';
  isActive = false;
  isOpen = false;
  isCustomDisclosure = false;
  membershipIds: number[] = [];
  shareIds: number[] = [];
  serviceIds: number[] = [];
}

export class OLALenderConfiguration {
  consumerLoanGroups: ConsumerLoanGroup[] = [new ConsumerLoanGroup()];
  masterActions: string[] = [];
  masterDisclosureList: Disclosure[] = [new Disclosure()];
  masterLoanProtectionOptionList: LoanProtectionOptionItem[] = [new LoanProtectionOptionItem()];
  masterUITemplates: MasterUITemplate[] = [new MasterUITemplate()];
  setting: OLASetting = new OLASetting();
  postAppNotificationTemplates: PostAppNotificationTemplate[];
}

export class PaymentMethod {
  creditDebitCard = false;
  achTransfer = false;
}

export class MembershipConfig {
  membershipId: number = null;
  separatedSigning = true;
  notificationMethod: NotificationMethod = NotificationMethod.EsignPartnerEmail;
  coAppInviteTemplateGUID = '';
  fundingVisibility: EsignFundingVisibility = EsignFundingVisibility.AllApplicant;
  coApplicantCanFund = true;
}

export class WidgetConfiguration {
  addNewConfig: TenantConfig = new TenantConfig();
}

export class ConsumerLoanGroup {
  groupId = '';
  displayName = '';
  groupIcon?: string;
  loanGroup = '';
  isLoanGroupHasProduct = false;
  isActive = false;
  hideInUI = false;
  loanProducts: AdminLoanProduct[] = [new AdminLoanProduct()];
}

export class LoanProtectionOptionItem {
  loanProtectionId = '';
  label = '';
  heading = '';
  information = '';
  isActive = false;
}

export class MasterUITemplate {
  uiTemplateId: number = null;
  templateName = '';
  path = '';
  nextStepsText = '';
}

export class OLASetting {
  canShowApplicationExperience = false;
  canShowPostApp = false;
  canShowDocManagement = false;
  canShowDynamicApp = false;
  canShowInstatouch = false;
  canShoweSign = false;
  canShowFundingForPersonalLoan = false;
  esignTasksAccess: CrossApplicantAccess = null;
  viewDocumentsAccess: CrossApplicantAccess = null;
  isOLACrossSellDisabled = false;
  hideEmployerPhone = false;
  isOLACrossSellAsSoonAsAvailable = false;
  allowPromotionCode = false;
  canShowTerm = false;
  canShowEstPayment = false;
  canShowRate = false;
  canShowEmployeeofLenderCheckbox = false;
  canShowEligibilityQuestions = false;
  showEligibilityPage = false;
  canShowCreditUnionContact = false;
}

export enum StateNames {
  Alabama,
  Alaska,
  Arizona,
  Arkansas,
  California,
  Colorado,
  Connecticut,
  Delaware,
  DistrictofColumbia,
  Florida,
  Georgia,
  Hawaii,
  Idaho,
  Illinois,
  Indiana,
  Iowa,
  Kansas,
  Kentucky,
  Louisiana,
  Maine,
  Maryland,
  Massachusetts,
  Michigan,
  Minnesota,
  Mississippi,
  Missouri,
  Montana,
  Nebraska,
  Nevada,
  NewHampshire,
  NewJersey,
  NewMexico,
  NewYork,
  NorthCarolina,
  NorthDakota,
  Ohio,
  Oklahoma,
  Oregon,
  Pennsylvania,
  RhodeIsland,
  SouthCarolina,
  SouthDakota,
  Tennessee,
  Texas,
  Utah,
  Vermont,
  Virginia,
  Washington,
  WestVirginia,
  Wisconsin,
  Wyoming,
  AmericanSamoa,
  Guam,
  NorthernMarianaIslands,
  PuertoRico,
  USVirginIslands,
  USMinorOutlyingIslands,
  Micronesia,
  MarshallIslands,
  Palau
}
export enum NotificationMethod {
  DirectEmail = 'Direct Email',
  EsignPartnerEmail = 'Esign Partner Email'
}

export enum EsignFundingVisibility {
  PrimaryApplicant = 'If at least primary applicant has signed documents',
  AllApplicant = 'Only if all applicants have signed documents'
}

export enum StateCodes {
  AL,
  AK,
  AZ,
  AR,
  CA,
  CO,
  CT,
  DE,
  DC,
  FL,
  GA,
  HI,
  ID,
  IL,
  IN,
  IA,
  KS,
  KY,
  LA,
  ME,
  MD,
  MA,
  MI,
  MN,
  MS,
  MO,
  MT,
  NE,
  NV,
  NH,
  NJ,
  NM,
  NY,
  NC,
  ND,
  OH,
  OK,
  OR,
  PA,
  RI,
  SC,
  SD,
  TN,
  TX,
  UT,
  VT,
  VA,
  WA,
  WV,
  WI,
  WY,
  AS,
  GU,
  MP,
  PR,
  VI,
  UM,
  FM,
  MH,
  PW
}

export class TenantConfig {
  globalTypes: GlobalType[] = [new GlobalType()];
}

export class AdminLoanProduct extends LoanProduct {
  productId = '';
  displayName = '';
  productName = '';
  collateralType = '';
  description = '';
  min = '';
  max = '';
  isSelectedRange = false;
  allowCoApplicant = true;
  allowCoSigner = true;
  showCoApplicantRelationship = true;
  requestAmountRanges: RequestAmountRange[] = [];
  loanProtectionOptions: string[] = [];
  disclosures: ProductDisclosure[] = [];
  olaLoanDetail: OLALoanDetail = new OLALoanDetail();
  lenderLoanProduct = '';
  uITemplateId: number = null;
  actions: string[] = [];
  docRefIds: string[] = [];
  isActive = false;
  excludedFields: string[] = [];
  excludedPages: string[] = [];
  excludedCards: string[] = [];
  allowPromotionCode = false;
  minMonthResidence: number = null;
  minMonthEmployment: number = null;
  postAppNotificationTemplateId: string = null;
  alloyJourneyId?: string;
}

export class SubTypeOption {
  name = '';
  label = '';
  canView = false;
  canActivate = false;
}

export class GlobalType {
  notes: string[] = [];
  subTypes: GlobalType[];
  options: SubTypeOption[];
  inputs: InputControl[];
  allowSearch = false;
  searchTemplate = '';
  successTemplate = '';
  actionButtons: ActionButton[];
  name = '';
  label = '';
  canView = false;
  canActivate = false;
}

export class RequestAmountRange {
  amountMin = '';
  amountMax = '';
  termMin = '';
  termMax = '';
  rangeValues: string[] = [];
}

export class InputControl extends SubTypeOption {
  required = false;
  maxlength: number = null;
  pattern = '';
}

// TODO: ESPControlFor is an Enum. Do these need to be converted to classes?
export class ActionButton extends SubTypeOption {
  allowCreate = false;
  type: ESPActionButtonType;
  for: ESPControlFor[];
  show = false;
}

export enum ESPActionButtonType {
  Reverse,
  Primary
}

export enum ESPControlFor {
  New,
  Exist
}

export enum OAOPaymentVendor {
  SWBC,
  ICG,
  NONE
}

export enum CrossApplicantAccess {
  OwnItems = 'OwnItems',
  SpouseItems = 'SpouseItems',
  AllItems = 'AllItems'
}

export class OAOFundingType {
  creditDebit = '';
  bankTransfer = '';
}

export class OAOICGConfig {
  applicationId = '';
  applicationSecret = '';
  siteId = '';
  siteKey = '';
}

export class FooterLinks {
  enableContactUsPanel = true;
  enableCustomLinks = false;
  links: FooterLink[] = [new FooterLink()];
}

export class FooterLink {
  id!: string;
  label = '';
  route = '';
}

export class AdminStipulation {
  adminStipulationId = '';
  isActive = true;
  displayName = '';
  stipulationName = '';
  description = '';
  documentCategory = '';
  fileNamePrefix = '';
}

export class GoogleAnalytics {
  accountId = '';
  isEnabled = false;
}

export class GoogleTagManager {
  accountId = '';
  isEnabled = false;
  allowList?: string;
  blockList?: string;
}

/**
 * Represents a unique Brand under a given DX subdomain
 * Brands give a different look and feel to DX subdomains that submit to the same Lender
 * OS behavior can be different per Brand (within the same Lender)
 */
export class Brand {
  id: null;
  name: null;
}
